import { useEffect } from 'react';
import { TransportBar } from '../features/transport/TransportBar';
import { SessionGrid } from '../features/session/SessionGrid';
import { ArrangementHost } from '../features/arrangement/ArrangementHost';
import { MixerView } from '../features/mixer/MixerView';
import { AudioClipEditor } from '../features/clip/AudioClipEditor';
import { MidiEditor } from '../features/clip/MidiEditor';
import { useStudioStore } from '../stores/studioStore';
import { useMixerStore } from '../stores/mixerStore';
import { clsx } from '../lib/utils';

/**
 * Phase 3 React shell:
 * - Owns transport + session UI in React
 * - SSL mixer view with Simple/Studio modes + channel inspector
 */
export function StudioApp() {
  const hydrateFromEngine = useStudioStore((s) => s.hydrateFromEngine);
  const view = useStudioStore((s) => s.project.view);
  const hydrated = useStudioStore((s) => s.hydrated);
  const fullscreen = useMixerStore((s) => s.fullscreen);
  const setInspectorOpen = useMixerStore((s) => s.setInspectorOpen);

  useEffect(() => {
    hydrateFromEngine();
  }, [hydrateFromEngine]);

  useEffect(() => {
    if (view === 'both') setInspectorOpen(false);
    else if (view === 'mix') setInspectorOpen(true);
  }, [view, setInspectorOpen]);

  return (
    <div className="sdpro-react-shell font-daw">
      {!fullscreen && <TransportBar />}
      <div className="flex min-h-0 flex-1 flex-col">
        {(view === 'session' || view === 'both') && !fullscreen && (
          <div className={view === 'both' ? 'max-h-[40%] min-h-[160px] border-b border-daw-border' : 'min-h-0 flex-1'}>
            <SessionGrid />
          </div>
        )}
        {(view === 'arrange' || view === 'both') && !fullscreen && (
          <div className="min-h-0 flex-1">
            <ArrangementHost />
          </div>
        )}
        {(view === 'mix' || view === 'both') && (
          <div
            className={clsx(
              'border-t border-daw-border',
              view === 'mix' || fullscreen
                ? 'min-h-0 flex-1'
                : 'max-h-[42%] min-h-[180px]',
            )}
          >
            <MixerView compact={view === 'both' && !fullscreen} />
          </div>
        )}
        {!fullscreen && (
          <>
            <AudioClipEditor />
            <MidiEditor />
          </>
        )}
      </div>
      {!hydrated && (
        <div className="pointer-events-none absolute inset-0 flex items-center justify-center bg-black/40 text-sm text-daw-muted">
          Connecting to audio engine…
        </div>
      )}
    </div>
  );
}
